export default "__VITE_ASSET__D3E3t3KN__"